<template>
  <div>
    <jt-dynamic-form
      v-if="form[0] && form[0].dadosForm"
      ref="dynamicForm"
      :inputs="filteredInputs"
      :buttons="form[0].buttons"
      :interface="form[0].nmInterface"
      :relacionamentos="form[0].relacionamentos"
      :model="negotiationController.getDadosFormResponsible(form[0].dadosForm, getClientName(), getClientId())"
      form-class="form"
      style="padding: 30px"
      @input="onFormInput"
    />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDataTable, JtInput, JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud
import NegotiationController from '../NegotiationController'
import ServiceRequestController from 'src/modules/concession/service-request/ServiceRequestController'

@Component({
  name: 'ResponsibleFormSteep',
  mixins: [page],
  components: {
    JtDataTable,
    JtInput
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ResponsibleFormSteep extends Vue {
  negotiationController = NegotiationController.getInstance();
  controller = ServiceRequestController.getInstance();
  form = {};

  get filteredInputs () {
    return this.form[0].inputs.filter(input => {
      if (input.name === 'legalRepresentativeName') {
        return !this.shouldShowLegalRepresentative()
      }
      return true
    })
  }

  shouldShowLegalRepresentative () {
    const ownerId = this.getOwnerId()
    const clientId = this.getClientId()
    if (clientId && ownerId) {
      const shouldShow = clientId === ownerId
      return shouldShow
    }
    return false
  }

  async mounted () {
    this.form = await this.getFormResponsible()
    this.negotiationController.setDisabledContinue(true)
  }

  @Watch('form', { deep: true, immediate: true })
  onFormChange () {
    this.validateForm()
  }

  onFormInput () {
    this.validateForm()
  }

  validateForm () {
    if (this.$refs.dynamicForm) {
      const isValid = this.$refs.dynamicForm.isValidForm()
      this.negotiationController.setDisabledContinue(!isValid)
    }
  }

  async getFormResponsible () {
    return await repository.resolve('agreementInvoice.agreementInvoiceResponsibleForm')
  }

  getClientName () {
    const serviceRequest = this.controller.state?.serviceRequests?.[this.protocol]
    return serviceRequest?.clientName
  }

  getClientId () {
    const serviceRequest = this.controller.state?.serviceRequests?.[this.protocol]
    return serviceRequest?.client || null
  }

  getOwnerId () {
    const consumerUnit = this.controller.state?.serviceRequests?.[this.protocol]?.consumerUnits?.[this.consumerUnit]
    return consumerUnit?.ownerId || null
  }
}

export default ResponsibleFormSteep
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
